
const actions = {

  /**
   * @param context
   */
  setAxiosError (context, error) {
    context.commit('SET_AXIOS_ERROR', error)
  },
  deleteAxiosError (context, error) {
    context.commit('DELETE_AXIOS_ERROR', error)
  },
  setWsStatus (context, status) {
    context.commit('SET_WS_STATUS', status)
  }
}

export default actions



//////////////////
// WEBPACK FOOTER
// ./state/error/error.actions.js
// module id = null
// module chunks = 